import getters from '@/store/modules/content/messageText/getters'
import mutations from '@/store/modules/content/messageText/mutations'
import actions from '@/store/modules/content/messageText/actions'

export default {
  namespaced: true,
  state() {
    return {
      messageTextList: [],
      messageText: {},
      messageTextMetadata: {}
    }
  },
  getters,
  actions,
  mutations
}
